export default {
  description: 'Os modelos excluídos ficam aqui por 7 dias. Depois disso são removidos definitivamente.',
  search: 'Buscar',
  empty: 'Nenhum modelo excluído',
  headerName: 'Nome',
  headerType: 'Tipo',
  headerDeletedBy: 'Excluído por',
  headerDeleted: 'Excluído',
  headerDaysLeft: 'Removido em',
  headerSource: 'Excluído de',
  daysLeft: '{count} dias',
  typeAdHoc: 'Ad-Hoc',
  typeDiy: 'DIY',
  typeCustomEkrm: 'Custom EKRM',
  typeCustomReference: 'Custom Ref.',
  typeEkrm: 'EKRM',
  source: {
    modelManager: 'Model Manager',
    automaticModels: 'Modelos DIY',
    adHocModels: 'Modelos Ad-Hoc',
    modelComposer: 'Model Composer',
    manageEkrm: 'Manage EKRM'
  },
  restore: 'Restaurar',
  restoreTitle: 'Restaurar modelo?',
  restoreMessage: '{name} voltará a estar disponível, com seus planos e os acessos que tinha.',
  restoreMessageEkrm: '{name} voltará a estar disponível em Manage EKRM.',
  nameConflict: 'Outro modelo está usando este nome agora. Escolha um nome diferente para restaurá-lo.',
  newNameLabel: 'Nome',
  restoredName: '{name} (restaurado)',
  cancel: 'Cancelar',
  close: 'Fechar',
  restored: '{name} foi restaurado.',
  reportPending: 'O relatório do modelo está sendo gerado.',
  warning: {
    'version-unlinked': 'Seu lugar na família de versões foi ocupado, então foi restaurado como um modelo independente.',
    'request-exists': 'Sua solicitação DIY já existia e foi mantida como estava.',
    'ekrm-missing': 'Seu EKRM não existe mais, então não aparecerá no Model Composer.'
  },
  error: {
    'target-exists': 'Outro modelo está usando o mesmo ID agora, então este não pode ser restaurado.',
    'storage-changed': 'Os arquivos do modelo foram substituídos por um modelo mais novo, então este não pode ser restaurado.',
    'trash-entry-not-found': 'Este modelo não está mais na lixeira.',
    'permission-denied': 'Você não tem permissão para restaurar este modelo.',
    unknown: 'Erro ao restaurar o modelo'
  }
}
